export const isBotOrLighthouse = () => {
  if (typeof window === 'undefined') return false;
  const ua = navigator.userAgent || '';
  return (
    ua.includes('Lighthouse') ||
    ua.includes('Chrome-Lighthouse') ||
    ua.includes('Googlebot') ||
    ua.includes('HeadlessChrome') ||
    ua.includes('Pingdom') ||
    ua.includes('GTmetrix') ||
    navigator.webdriver // true if it's a headless browser (Puppeteer, Selenium, etc.)
  );
};
